import { render, staticRenderFns } from "./ChatContextSelector.vue?vue&type=template&id=44ad1e36&scoped=true"
import script from "./ChatContextSelector.vue?vue&type=script&lang=js"
export * from "./ChatContextSelector.vue?vue&type=script&lang=js"
import style0 from "./ChatContextSelector.vue?vue&type=style&index=0&id=44ad1e36&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44ad1e36",
  null
  
)

export default component.exports